export default __webpack_public_path__ + "static/media/bill-of-lading.486a98cb.webp";